<template>
    <div class="body_container main_context" ref="windows">
        <div class="input_zone">
            <!-- <div class="next_botton_div">
        <el-button style="margin-left: 10px" size="small" type="primary" plain :disabled="step_num===1?true:false" @click="previousStep()" >
            Previous step
        </el-button>
        <el-button style="margin-left: 10px" size="small" type="primary" plain :disabled="step_num===step_count?true:false" @click="nextStep()" >
            Next step
        </el-button>
            </div>-->
            <el-steps :active="step_num" :align-center="false" class="steps">
                <el-step title="Upload your GWAS summary file" icon="el-icon-upload"></el-step>
                <el-step title="Fill the options" icon="el-icon-edit"></el-step>
                <el-step title="Submitted" icon="el-icon-picture"></el-step>
            </el-steps>
            <div class="steps-context" ref="steps_context">
                <div class="step">
                    <el-form ref="form" :model="form" label-width="80px">
                        <div class="gwas-tips">
                             The GWAS summary file must be a tab or comma delimited text file containing columns of SNP coordinates (chromosome number, base pair postion), 
                             the two alleles (A1 and A2), frequencies of the A1, the effect sizes (odds ratio or regression coefficient) and its standard errors. 
                            The file size cannot exceed 200MB. We strongly recommend you to compress your file 
                            by <a style="text-decoration:none;color:#409EFF" href="https://www.gzip.org/">gzip</a> to reduce upload time. 

                            <p style="font-style:italic; font-weight:500;">We promise to keep every user's submitted data private. 
                            <a style="text-decoration:none;color:#409EFF" href="#/document?id=1-8">Data Privacy Policy</a></p> 
                        </div>
                        <p><span style="font-style:italic; font-weight:550;font-size:14px">Example GWAS summary file format:</span></p>
                        <div class="code">
                            CHR BP A1 A2 FRQ_U OR SE<br>
                            1 68677760 C T 0.824 0.0114 0.983<br>
                            1 69228887 T C 0.957 0.398 0.831<br>
                            1 66053488 C A 0.721 0.996 0.991<br>
                            ...<br>
                        </div>
                        <el-upload class="gwas-upload"
                            :file-list="file_list"
                            :auto-upload="false"
                            drag
                            ref="upload"
                            :on-success="succssUpload"
                            :multiple="false"
                            :limit="1"
                            :show-file-list="true"
                            :before-upload="checkUpload"
                            :on-error="uploadError"
                            :on-progress="uploadProgress"
                            :on-change="changeFile"
                            :on-remove="removeFile"
                            :on-exceed="exceedFile"
                            :action="upload_url"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                Drag file to here or
                                <em>click to select file</em>
                            </div>

                        </el-upload>
                    <div class="upload_btn">
                    <div class="tip_box" v-if="uploadDisable">
                        <i class="el-icon-loading"></i> The file is being uploaded. 
                        <span style="color:red">DO NOT exit or refresh the page. </span>
                         The web page will automatically jump to the next step after the file is uploaded successfully.
                    </div>
                            <a :href="example_gwas"
                                class="primary_link example_a"
                                target="_blank"
                            >Example GWAS file</a>
                        <el-button
                            type="success"
                            @click="submitExample"
                            :disabled="exampleUploadDisable"
                        >Submit with example file</el-button>
                        <el-button
                            type="primary"
                            @click="submitUpload"
                            :disabled="uploadDisable"
                        >Upload to server</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="step">
                    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="280px">
                        <i slot="suffix" class="el-icon-question"></i>
                        <el-form-item prop="task_label">
                            <span slot="label">
                                <span class="span-box">{{label_tips['task_label']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['task_label']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-input v-model="ruleForm.task_label"></el-input>
                        </el-form-item>
                        <el-form-item prop="chr">
                            <span slot="label">
                                <span class="span-box">{{label_tips['chr']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['chr']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.chr" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="bp">
                            <span slot="label">
                                <span class="span-box">{{label_tips['bp']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['bp']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.bp" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item prop="a1">
                            <span slot="label">
                                <span class="span-box">{{label_tips['a1']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['a1']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.a1" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item prop="a2">
                            <span slot="label">
                                <span class="span-box">{{label_tips['a2']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['a2']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.a2" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="freq_a1">
                            <span slot="label">
                                <span class="span-box">{{label_tips['freq_a1']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['freq_a1']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.freq_a1" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="effect_size_type">
                            <span slot="label">
                                <span class="span-box">{{label_tips['effect_size_type']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['effect_size_type']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.effect_size_type" placeholder>
                                <el-option
                                    v-for="col in gwas_effect_size_type"
                                    :key="col.value"
                                    :label="col.label"
                                    :value="col.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="effect_size">
                            <span slot="label">
                                <span class="span-box">{{label_tips['effect_size']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['effect_size']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.effect_size" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="se">
                            <span slot="label">
                                <span class="span-box">{{label_tips['se']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['se']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.se" placeholder>
                                <el-option
                                    v-for="col in gwas_columns"
                                    :key="col"
                                    :label="col"
                                    :value="col"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="ref_genome">
                            <span slot="label">
                                <span class="span-box">{{label_tips['ref']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['ref']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.ref_genome" placeholder>
                                <el-option
                                    v-for="item in genomeVal"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="pop">
                            <span slot="label">
                                <span class="span-box">{{label_tips['pop']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['pop']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.pop" placeholder>
                                <el-option
                                    v-for="item in populationVal"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="ref_eqtl">
                            <span slot="label">
                                <span class="span-box">{{label_tips['ref_eqtl']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['ref_eqtl']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.ref_eqtl" placeholder>
                                <el-option
                                    v-for="col in eqtl_files"
                                    :key="col.name"
                                    :label="col.text"
                                    :value="col.name"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="ref_eqtl_type">
                            <span slot="label">
                                <span class="span-box">{{label_tips['ref_eqtl_type']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['ref_eqtl_type']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-select v-model="ruleForm.ref_eqtl_type" placeholder>
                                <el-option
                                    v-for="col in ref_eqtl_types"
                                    :key="col.name"
                                    :label="col.text"
                                    :value="col.name"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="filter_eqtl_p">
                            <span slot="label">
                                <span class="span-box">{{label_tips['filter_eqtl_p']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['filter_eqtl_p']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-input v-model="ruleForm.filter_eqtl_p"></el-input>
                        </el-form-item>
                        <el-form-item prop="ld_pruning_mr">
                            <span slot="label">
                                <span class="span-box">{{label_tips['ld_pruning_mr']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['ld_pruning_mr']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-input v-model="ruleForm.ld_pruning_mr"></el-input>
                        </el-form-item>
                        <el-form-item prop="emic_pfm_p">
                            <span slot="label">
                                <span class="span-box">{{label_tips['emic_pfm_p']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['emic_pfm_p']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-input v-model="ruleForm.emic_pfm_p"></el-input>
                        </el-form-item>

                        <el-form-item prop="emic_plot_p">
                            <span slot="label">
                                <span class="span-box">{{label_tips['emic_plot_p']['label']}}
                                    <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['emic_plot_p']['tip']" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-input v-model="ruleForm.emic_plot_p"></el-input>
                        </el-form-item>
                        <el-form-item
                            prop="email"
                            label="Email (optional)"
                            :rules="[
                            { required: false, message: 'Input your email address and you will be notified when the task is complete.', trigger: 'blur' },
                            { type: 'email', message: 'Please input correct email', trigger: ['blur', 'change'] }
                            ]"
                        >
                        <span slot="label">
                            <span class="span-box">{{label_tips['email']['label']}}
                                <el-tooltip style="diaplay:inline" effect="dark" :content="label_tips['email']['tip']" placement="top">
                                    <i class="el-icon-question" />
                                </el-tooltip>
                            </span>
                        </span>
                        <el-input v-model="ruleForm.email" :placeholder="label_tips['email']['placeholder']"></el-input>
                        </el-form-item>
                        <el-button
                            type="success"
                            @click="fillExampleOptions" :disabled='!with_example'
                        >Submit with example options</el-button>
                        <el-button type="primary" @click="submitForm('ruleForm')" :disabled='with_example'>Submit</el-button>
                        <el-button @click="resetForm('ruleForm')" :disabled='with_example'>Reset</el-button>
                    </el-form>
                </div>
                <div class="step">
                    <el-result
                        icon="success"
                        title="Submit sucessfully"
                        subTitle="The task has been sumbitted sucessfully! The task will run about 30 minuters in our server. 
          Please click the botton below to check your results."
                    >
                        <template slot="extra">
                            <el-button
                                type="primary"
                                size="medium"
                                @click="goResultLink"
                            >Check result</el-button>
                        </template>
                    </el-result>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios/dist/axios.min";
import { api_dir,backTop,pcga_options_tips } from "@/bus.js";
export default {
    name: "AnalyzePhenotype",
    data() {
        var isNumber = (val) => {
            var regPos = /^\d+(\.\d+)?$/; //非负浮点数
            var regNeg =
                /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
            if (regPos.test(val) || regNeg.test(val)) {
                return true;
            } else {
                return false;
            }
        };
        var checkNumber = (rule, value, callback) => {
            console.log(value);
            if (!value) {
                console.log(value);
                return callback(new Error("Input a number"));
            }
            if (!isNumber(value)) {
                callback(new Error("Input a number, not characters"));
            } else {
                callback();
            }
        };
        var checkNumberLessThan = (rule, value, callback) => {
            console.log(value);
            if (!value) {
                console.log(value);
                callback(new Error("Input a number"));
            }
            if (!isNumber(value)) {
                callback(new Error("Input a number, not characters"));
            } else {
                if(value>0.001){
                    callback(new Error("This value must be less than 0.001"));
                }
                callback();
            }
        };
        return {
            label_tips:pcga_options_tips,
            with_example:false,
            step_num: 1,
            step_count: 1,
            example_gwas: "static/resource/example/scz_gwas_eur_chr1.tsv.gz",
            upload_url:api_dir+'/api.php?action=common_upload&func=emic',
            gwas_columns: [],
            ruleForm: {
                func:"emic",
                task_id: "",
                task_label: "",
                ref_genome: "",
                chr: "",
                bp: "",
                a1:"",
                a2:"",
                freq_a1:"",
                effect_size_type:"",
                effect_size:"",
                se:"",
                ref_eqtl:'',
                ref_eqtl_type:'gene',
                filter_eqtl_p:1E-4,
                ld_pruning_mr:0.9,
                emic_pfm_p:2.5E-6,
                emic_plot_p:1E-4,
                pop: "",
                email:'',
            },
            gwas_effect_size_type:[
                {label:'Linear regression coefficient of a quantitative phenotype',value:'0'},
                {label:'Logarithm of odds ratio or logistic regression coefficient of a qualitative phenotype',value:'1'},
                {label:'Odds ratio of a qualitative phenotype',value:'2'},
            ],
            ref_eqtl_types:[
                {name:'gene',text:'gene'},
                {name:'transcript',text:'transcript'},
            ],
            go_task_id:'',

            rules: {
                task_label: [{ required: true, message: 'Specify a label for the job', trigger: 'blur' },
                { min: 1, max: 30, message: 'The label length should be in 3-30 characters.', trigger: 'blur' }],
                ref_genome: [{ required: true, message: 'Select reference genome version', trigger: 'change' }],
                chr: [{ required: true, message: 'Select a value', trigger: 'change' }],
                bp: [{ required: true, message: 'Select a value', trigger: 'change' }],
                p: [{ required: true, message: 'Select a value', trigger: 'change' }],
                a1: [{ required: true, message: 'Select a value', trigger: 'change' }],
                a2: [{ required: true, message: 'Select a value', trigger: 'change' }],
                freq_a1: [{ required: true, message: 'Select a value', trigger: 'change' }],
                effect_size_type: [{ required: true, message: 'Select a value', trigger: 'change' }],
                effect_size: [{ required: true, message: 'Select a value', trigger: 'change' }],
                se: [{ required: true, message: 'Select a value', trigger: 'change' }],
                filter_eqtl_p:[{ validator: checkNumberLessThan, trigger: 'change' }],
                ld_pruning_mr: [{validator: checkNumber, trigger: 'blur' }],
                emic_pfm_p: [{validator: checkNumber, trigger: 'blur' }],
                emic_plot_p: [{validator: checkNumber, trigger: 'blur' }],
                pop: [{ required: true, message: 'Select a value', trigger: 'change' }],
                ref_eqtl: [{ required: true, message: 'Select a value', trigger: 'change' }],
                ref_eqtl_type: [{ required: true, message: 'Select a value', trigger: 'change' }],
                fwer: [{ validator: checkNumber, trigger: 'blur' }],
                max_gene:[{ validator: checkNumber, trigger: 'blur' }],
            },

            populationVal: [
                { value: "EUR", text: "EUR (European)" },
                { value: "EAS", text: "EAS (East Asian)" },
                { value: "AFR", text: "AFR (African)" },
                { value: "AMR", text: "AMR (Admixed American)" },
                { value: "SAS", text: "SAS (South Asian)" },
            ],

            genomeVal: [
                { value: "hg19", text: "hg19/GRCh37" },
                { value: "hg38", text: "hg38/GRCh38" },
            ],

            gwasColNames: [
                { name: "chr", text: "Chromosome number column" },
                { name: "bp", text: "Base pair position column" },
                { name: "pvalue", text: "P value column" },
            ],
            eqtl_files: [],
            result_url: '',

            github_GWAS: "https://github.com/pmglab/SPA/tree/main/extra",
            uploadDisable:false,
            exampleUploadDisable:false,
            file_list:[],
        };
    },

    mounted: function () {
        this.monitorStep();
        this.getOptions();
    },
    watch: {
        step_num: function () {
            this.monitorStep();
            backTop();
        },
        file_list:function(){
             console.log('go');
            if(this.file_list.length>0){
                console.log('go')
                this.uploadDisable=true;
            }
        }
    },
    methods: {
        submitUpload() {
            this.$refs.upload.submit();
        },
        submitExample(){
            var _this=this;
                _this.with_example=true;
                var ruleForm= {
                    task_label: "Example_SCZ_EMIC",
                    ref_genome: "hg19",
                    chr: "CHR",
                    bp: "BP",
                    pop: "EUR",
                    task_id: "",
                    a1:"A1",
                    a2:"A2",
                    freq_a1:"FRQ_U",
                    effect_size_type:"2",
                    effect_size:"OR",
                    se:"SE",
                    ref_eqtl:'Brain_Frontal_Cortex_BA9',
                    ref_eqtl_type:'gene',

                }
                for(var k in ruleForm){
                    _this.$data.ruleForm[k]=ruleForm[k];
                }
                _this.step_num += 1;
        },

        checkUpload(file){
            const maxFilesize=200*1024*1024;
            if(file.size>maxFilesize){
                this.$refs.upload.clearFiles();
            this.uploadDisable=false;
                        this.$notify({
                title: "Check failed",
                message: 'File size cannot exceed 200MB!',
                type: "error",
                duration: 5000,
            });
                return false;
            }else{
                return true;
            }
        },
        uploadError(){
            this.$refs.upload.clearFiles();
            this.uploadDisable=false;
                this.$notify({
                title: "Upload failed",
                message: 'Upload failed! Please check the network!',
                type: "error",
                duration: 5000,
            });
            this.$message.error('');
        },
        uploadProgress(){
            this.uploadDisable=true;
        },
        changeFile(){
            this.exampleUploadDisable=true;
            console.log(this.file_list)
        },
        removeFile(){
            this.exampleUploadDisable=false;
            console.log(this.file_list)
        },
        exceedFile(){
            this.$notify({
                title: "Only allow one file",
                message: 'Remove existing file before re-selecting another file',
                type: "error",
                duration: 5000,
            });
        },
        succssUpload(res, file, fileList) {
            if ('file_header_error' in res) {
                this.$notify({
                    title: "Illegal file",
                    message: res['file_header_error'],
                    type: "error",
                    duration: 5000,
                });
                this.$refs.upload.clearFiles();
                this.uploadDisable=false;
            } else {
                this.uploadDisable=false;
                this.$notify({
                    title: "Success",
                    message: "Uploaded successfully",
                    type: "success",
                    duration: 4000,
                });
                this.gwas_columns = res["file_header"];
                this.ruleForm.task_id = res["task_id"];
                console.log(this.ruleForm);
                this.step_num += 1;
                //   console.log(res, file, fileList);
            }
        },
        nextStep() {
            this.step_num += 1;
        },
        previousStep() {
            this.step_num -= 1;
        },

        monitorStep() {
            var steps = this.$refs.steps_context.children;
            this.step_count = steps.length;
            for (var i = 0; i < steps.length; i++) {
                if (i + 1 == this.step_num) {
                    steps[i].style.display = "block";
                } else {
                    steps[i].style.display = "none";
                }
            }
        },
        submitForm(formName) {
            if (this.ruleForm.task_id == '') {
                this.$notify({
                    title: "Illegal operation",
                    message: 'Please upload GWAS summary file',
                    type: "error",
                    duration: 5000,
                });
                return false;
            } else {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var para = this.ruleForm;
                        var _this = this;
                        axios
                            .get(api_dir + "/api.php?action=common_submit_task", {
                                params: para,
                            })
                            .then(function (response) {
                                var res = JSON.parse(JSON.stringify(response.data));
                                if(res.error_code==0){
                                    _this.step_num += 1;
                                    _this.ruleForm.task_id = '';
                                    _this.$refs.upload.clearFiles();
                                    _this.$refs.ruleForm.resetFields();
                                    console.log(res);
                                    _this.$notify({
                                        title: "Success",
                                        message: "Submited successfully",
                                        type: "success",
                                        duration: 2000,
                                    });
                                    _this.go_task_id = res.task_id;
                                }else{
                                    _this.$notify({
                                        title: "Illegal operation",
                                        message: 'No such task_id',
                                        type: "error",
                                        duration: 5000,
                                    });
                                    return false;
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    } else {
                        return false;
                    }
                });
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        goResultLink() {
            this.$router.push({path:'/results/common_task_emic?task_id='+this.go_task_id});
        },
        fillExampleOptions(){
            var _this=this;
            axios
            .get(api_dir + "/api.php?action=common_get_example_id&func=emic")
            .then(function (response) {
                var res = JSON.parse(JSON.stringify(response.data));
                if(res.error_code==0){
                    _this.step_num += 1;
                    _this.ruleForm.task_id = '';
                    _this.$refs.upload.clearFiles();
                    _this.$refs.ruleForm.resetFields();
                    console.log(res);
                    _this.$notify({
                        title: "Success",
                        message: "Submited successfully",
                        type: "success",
                        duration: 2000,
                    });
                    _this.go_task_id = res.task_id;
                }else{
                    _this.$notify({
                        title: "Illegal operation",
                        message: 'No such task_id',
                        type: "error",
                        duration: 5000,
                    });
                    return false;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },

        getOptions(){
            var _this=this
            axios
                .get(api_dir + "/api.php?action=emic_eqtl", {
                }).then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));
                    var eqtls=[];
                    for(var it of res){
                        eqtls.push({'name':it['tissue'],'text':it['tissue']});
                    }
                    _this.eqtl_files=eqtls;
                })
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.context_main_body {
    width: 100%;
    min-height: 800px;
}
.example_a{
    padding-right: 20px;
}

.steps{
    margin: 20px 40px;
}
.steps-context{
    margin: 50px 40px;
}

.gwas-upload{
    margin: 30px auto;
}

.gwas-tips{
    line-height: 24px;
    font-size: 16px;
}

.upload_btn{
    margin-top: 20px;
}

.tip_box {
    padding: 15px 20px;
    background-color: #fdf6ec;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 12px;
}

.step >>> .el-form-item__label{
    font-weight: 550;
    font-size: 15px;
}

.code{
    padding:10px 15px;
    background-color: #FDF6E3;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    font-size: 13px;
    font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
    line-height: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/analyze_emic.vue